<mat-card class="w-50">
    <mat-card-subtitle>Aparência</mat-card-subtitle>
    <mat-card-content>
        <mat-button-toggle-group [value]="temaSelecionado" [disabled]="salvando" (change)="selecionar($event.value)" aria-label="Tema">
            <mat-button-toggle value="claro">
                <mat-icon class="align-middle">light_mode</mat-icon>
                <span class="align-middle px-1">Claro</span>
            </mat-button-toggle>
            <mat-button-toggle value="escuro">
                <mat-icon class="align-middle">dark_mode</mat-icon>
                <span class="align-middle px-1">Escuro</span>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </mat-card-content>
</mat-card>
